// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Check: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7">
            <path
                fill="currentColor"
                d="M5.69317845,10.8625378 L10.868173,5.46499381 C11.0439023,5.28168998 11.0439023,4.98451505 10.868173,4.80122913 L10.2317915,4.13746444 C10.0560621,3.95417852 9.77112208,3.95417852 9.59539275,4.13746444 L5.37498768,8.53935245 L3.40457725,6.4842118 C3.22884792,6.30090797 2.94390788,6.30090797 2.76817854,6.4842118 L2.131797,7.14797648 C1.95606767,7.33128031 1.95606767,7.62845524 2.131797,7.81174117 L5.05679691,10.8625199 C5.23250907,11.0458237 5.51743195,11.0458237 5.69317845,10.8625378 Z"
                transform="translate(-2 -4)"
            />
        </svg>
    );
};

export default React.memo(Check);
